var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('div',{staticClass:"card-item-header"},[_c('i',{staticClass:"green-arrow stats-icon fa-3x",class:_vm.icon}),_c('h3',[_vm._v(_vm._s(_vm.title))])]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('div',{staticClass:"card-item-footer"},[_c('hr'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }